function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewAsk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#27292b",
    d: "M136.813 136.862c-.737 14.637-7.02 28.899-18.776 39.507-11.721 10.608-26.537 15.417-41.184 14.685-14.646-.752-28.906-7.025-39.526-18.752-10.593-11.745-15.382-26.556-14.665-41.221.747-14.628 7.025-28.888 18.756-39.488 11.737-10.598 26.556-15.417 41.198-14.676 14.655.733 28.902 7.006 39.511 18.743 10.61 11.727 15.4 26.556 14.686 41.202m57.545 104.068L142.46 183.5c10.537-13.316 16.346-29.285 17.172-45.471a79.84 79.84 0 0 0-20.536-57.7c-14.792-16.361-34.93-25.226-55.33-26.249-20.414-1.05-41.336 5.754-57.663 20.544C9.716 89.426.865 109.535-.156 129.934a79.75 79.75 0 0 0 20.526 57.69c14.795 16.36 34.93 25.235 55.338 26.258 16.182.828 32.675-3.364 46.983-12.507l51.879 57.42c4.946 5.473 13.376 5.887 18.833.952 5.47-4.933 5.889-13.364.955-18.817",
    style: {
      strokeWidth: 0.352778
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAsk);
export default __webpack_public_path__ + "static/media/new_ask.8ca8b9bb2a00a75dd5fe0c7a2da0ca19.svg";
export { ForwardRef as ReactComponent };